import React, { Component } from 'react';
import Flatpickr from 'react-flatpickr'
import plus from '../img/plus.svg';


class GCUserImport extends Component {
	constructor(props) {
		super(props);
		this.state = {
			active: false,
			showBox: false,
			loading: false,
		};
	}

	/*
	editParam = (param, data) => (e) => {
		console.log('editParam')

		var newSetting = Object.assign({}, this.state.selectedObject)

		if (data) {
			newSetting[param] = data

		} else {
			newSetting[param] = e.target.value

		}
		this.setState({ selectedObject: newSetting, loading: false })
		
		console.log(this.state);
	}
    
	toggle = (param) => (e) => {
		console.log('toggle')
	    
		var newSetting = Object.assign({}, this.state.selectedObject)
		newSetting[param] = this.state.selectedObject[param] ? false : true
		this.setState({ selectedObject: newSetting, loading: false })
	}
	
	confirmChanges = (data, map) => (e) => {
		console.log('function: confirmChanges');
		
		var errorFound = false;

		if (map.type == 'specialMessages') {

		} else if (map.type == 'transferNumbers') {
			if (data.Phone_Number == '' || data.Phone_Number.length != 10 || isNaN(data.Phone_Number)) {
				errorFound = 'Please enter valid 10-digit phone number.';
			}
		}

		if(errorFound) {
			this.setState({error: errorFound});
		} else {
			console.log('no error');
			this.props.ws.send(JSON.stringify({ route: 'editIVRSettings', setting: data, map: map }))
			this.cancel();
		}

	}
	*/

	showBox = (type, obj) => e => {
		console.log('function: showBox');
		console.log(type);

		this.setState({
			showBox: type,
			setting: {},
			loading: false,
			selectedObject: obj
		})
	}

	setFileName = (e) => {
		if (e.target.files.length > 0) {
			this.setState({ file: e.target.files[0] })
		} else {
			this.setState({ file: false })
		}
		this.fileReader = new FileReader()
		this.fileReader.onload = (event) => {
			var send = Object.assign({}, this.state.send)
			send.file = this.fileReader.result.split(';base64,').pop()
			this.setState({ send: send, sendError: false })
		}
		this.fileReader.readAsDataURL(e.target.files[0])
	}

	confirmSend = () => {
		console.log('function: confirmSend');
		if (!this.state.file || this.state.file.name.slice(-3) != 'csv') {
			this.setState({ showError: "Please upload a csv file." })
		} else {
			console.log('no error')
			this.setState({
				loading: true,
				showBox: 'processImport'
			});
			this.props.ws.send(JSON.stringify({ route: 'importGCUsers', csv: this.state.send }))
			this.cancel();
		}
	}

	cancel = () => {
		console.log('function: cancel');
		this.setState({
			showBox: false,
			loading: false,
			selectedObject: false,
			originalObject: false,
			selectedSetting: false,
			selectedObject: false,
			selectedObjectMap: false,
			error: false,
			file: false,
			send: false
		})
	}

	componentWillReceiveProps(nextProps) {
		if (this.state.loading) { this.cancel(); }
	}

	render() {
		console.log('function: render');

		if (this.props.active) {

			var contentMain = [];
			var contentEditBox = [];

			//creating this object by value instead of by reference
			var data = JSON.parse(JSON.stringify(this.props.data.GCUserImport.data));

			let content = [];
			let historyList = [];

			//convert data to array
			data = Object.values(data);

			//sort data by date
			data.sort(function (a, b) {
				return new Date(b.startDate) - new Date(a.startDate);
			});

			for (let i in data) {
				let row = data[i];
				console.log('row');
				console.log(row);

				let date = new Date(row.startDate);
				let formattedDate = date.toLocaleString('en-US', {
					weekday: 'short',
					month: 'short',
					day: 'numeric',
					year: 'numeric',
					hour: 'numeric',
					minute: 'numeric',
					second: 'numeric',
					hour12: true
				}).replace(' at', '');

				historyList.push(
					<div className="dataRow" key={row.id} onClick={row.statusDescription == "Complete" ? this.showBox('viewStatus', row) : ''}>
						<span style={{ flex: '1 0 300px' }} >{formattedDate}</span>
						<span style={{ flex: '1 0 50px' }} >{row.userList.length}</span>
						<span style={{ flex: '1 0 50px' }} >{row.errorList.length}</span>
						<span style={{ flex: '1 0 300px' }} >{row.statusDescription}</span>
					</div>
				)
			}

			content.push(
				<div><img src={plus} className="plusButton" alt="New Import" onClick={this.showBox('uploadFile')} /></div>
			)

			content.push(
				<div>
					<h2 style={{ textAlign: 'center' }}>User Import</h2>
					<div className="dataHeaders">
						<span style={{ flex: '1 0 300px', cursor: 'pointer', textAlign: 'left' }}>Date</span>
						<span style={{ flex: '1 0 50px', cursor: 'pointer' }}>Users</span>
						<span style={{ flex: '1 0 50px', cursor: 'pointer' }}>Errors</span>
						<span style={{ flex: '1 0 300px', cursor: 'pointer' }}>Result</span>
					</div>
					<div style={{ overflow: 'auto', height: 'calc(100% - 85px)' }}>
						{historyList}
					</div>
				</div>
			)

			console.log('showbox');
			console.log(this.state.showBox);
			if (this.state.showBox == "uploadFile") {
				contentEditBox.push(
					<div className="blackout" tabIndex="1" autoFocus>
						<div className="pop">
							<div className="viewCloser" onClick={this.cancel}></div>
							<br />
							<div>You are starting a new import...</div>
							<br />
							<div style={{ textAlign: 'left' }}>Required columns:<br />name<br />email<br />password (only required for new users)</div>
                            <br />
                            <div style={{ textAlign: 'left' }}>Optional columns:<br />acdAutoAnswer (TRUE or FALSE)<br />employeeId (BSCID)</div>
							<br />
							<div><a href={window.location.origin.replace(':3000', ':8765') + "/GcUserImportExampleCsv.csv"}>Download Example CSV</a></div>


							<br />
							<input style={{ width: '0.1px', height: '0.1px', opacity: '0', overflow: 'hidden', position: 'absolute', zIndex: '-1' }} type="file" id="csv" accept=".csv" onChange={this.setFileName} />

							{this.state.file ?
								<div >
									<label style={{ display: 'inline-block', border: '1px solid #379', borderTopRightRadius: '0px', borderBottomRightRadius: '0px' }} className="button" htmlFor="csv">Browse</label>

									<span style={{ display: 'inline-block', border: '1px solid #379', padding: '15px 29px', fontSize: '25px', borderTopLeftRadius: '0px', borderBottomLeftRadius: '0px', borderTopRightRadius: '5px', borderBottomRightRadius: '5px' }}>{this.state.file.name.split('\\')[this.state.file.name.split('\\').length - 1]}
									</span>
									<br /><br />
									{this.state.showError ? <div className="error">{this.state.sendError}<br /><br /></div> : ''}

									<div className="button" onClick={this.confirmSend}>Begin Import</div>
								</div>

								:
								<div style={{ margin: '25px' }}>
									<label className="button" htmlFor="csv">Browse</label>
								</div>
							}

						</div>
					</div>
				)

			} else if (this.state.showBox == "viewStatus") {
				let resultList = [];
				let date = new Date(this.state.selectedObject.startDate);
				let formattedDate = date.toLocaleString('en-US', {
					weekday: 'short',
					month: 'short',
					day: 'numeric',
					year: 'numeric',
					hour: 'numeric',
					minute: 'numeric',
					second: 'numeric',
					hour12: true
				}).replace(' at', '');

				for (let i in this.state.selectedObject.resultList) {
					resultList.push(this.state.selectedObject.resultList[i]);
				}

				for (let i in this.state.selectedObject.errorList) {
					resultList.push(this.state.selectedObject.errorList[i]);
				}

				resultList.push(this.state.selectedObject.statusDetail);

				contentEditBox.push(
					<div className="blackout" tabIndex="1" autoFocus>
						<div className="pop" style={{width: '75%'}}>
							<div className="viewCloser" onClick={this.cancel}></div>
							<div>Import details for {formattedDate}</div>

							<br />
							<input style={{ width: '0.1px', height: '0.1px', opacity: '0', overflow: 'hidden', position: 'absolute', zIndex: '-1' }} type="file" id="csv" accept=".csv" onChange={this.setFileName} />

							<div>
								<textarea style={{width: '100%', height: '400px', resize:'none', overflow: 'scroll', overflowWrap: 'normal', whiteSpace: 'pre'}} readOnly>{resultList.join('\n')}</textarea>
							</div>

							<br />

							<div className="button" onClick={this.cancel}>Done</div>

						</div>
					</div>
				)
			}

			return (
				<div className="viewContent" id="reportView" >
					<div style={{ overflow: 'auto', height: 'calc(100% - 85px)' }}>
						{content}
					</div>
					{contentEditBox}
				</div>
			);
		} else {
			return (<div width="100%" />);
		}
	}
}

const icon = "menuWorkflow"
const roles = ["View"]
export { GCUserImport, icon, roles }